/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NextPortBlacklist } from './NextPortBlacklist';
import {
    NextPortBlacklistFromJSON,
    NextPortBlacklistFromJSONTyped,
    NextPortBlacklistToJSON,
} from './NextPortBlacklist';

/**
 * 
 * @export
 * @interface NextportBlacklistGet200Response
 */
export interface NextportBlacklistGet200Response {
    /**
     * 
     * @type {Array<NextPortBlacklist>}
     * @memberof NextportBlacklistGet200Response
     */
    records: Array<NextPortBlacklist>;
}

/**
 * Check if a given object implements the NextportBlacklistGet200Response interface.
 */
export function instanceOfNextportBlacklistGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function NextportBlacklistGet200ResponseFromJSON(json: any): NextportBlacklistGet200Response {
    return NextportBlacklistGet200ResponseFromJSONTyped(json, false);
}

export function NextportBlacklistGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextportBlacklistGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': ((json['records'] as Array<any>).map(NextPortBlacklistFromJSON)),
    };
}

export function NextportBlacklistGet200ResponseToJSON(value?: NextportBlacklistGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': ((value.records as Array<any>).map(NextPortBlacklistToJSON)),
    };
}

